const runtimeCfg = window.__APP_CONFIG__ || {};
const toBool = v => (typeof v === "boolean" ? v : String(v).toLowerCase() === "true");

const configs = {
  apiUrl: runtimeCfg.BASE_URL || process.env.REACT_APP_BASE_URL || "",
  signalRUrl: runtimeCfg.SIGNALR_URL || process.env.REACT_APP_SIGNALLER_URL || ""
};

export { configs };

// runtime wins; fallback to build-time
export const IS_GUEST_VIEW = toBool(
  runtimeCfg.GUEST_VIEW != null ? runtimeCfg.GUEST_VIEW : process.env.REACT_APP_GUEST_VIEW
);